import { render, staticRenderFns } from "./WechatPayLog.vue?vue&type=template&id=b133a030&scoped=true"
import script from "./WechatPayLog.vue?vue&type=script&lang=js"
export * from "./WechatPayLog.vue?vue&type=script&lang=js"
import style0 from "./WechatPayLog.vue?vue&type=style&index=0&id=b133a030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b133a030",
  null
  
)

export default component.exports